import { useFeatureFlagEnabled } from 'posthog-js/react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FEATURE_FLAGS } from 'support/helpers/featureFlags/featureFlags';
import { isLocal, isStaging } from 'support/helpers/generic/generic';

type FeatureFlagGuardProps = {
  featureFlag: FEATURE_FLAGS;
  to: string;
  children: React.ReactNode;
};
export const FeatureFlagGuard = ({ featureFlag, to, children }: FeatureFlagGuardProps) => {
  const navigate = useNavigate();
  const enabled = useFeatureFlagEnabled(featureFlag);

  useEffect(() => {
    if (isStaging() || isLocal()) {
      return;
    }

    if (enabled === false) {
      navigate(to, { replace: true });
    }
  }, [enabled, navigate, to]);

  if (enabled || isStaging() || isLocal()) {
    return <>{children}</>;
  }

  return null;
};
